import ApiServiceWrapper from '@/shared/api-request.service';
import { UserGroupReponse } from '@/modules/msw-accessmgmt/components/userGroupTypes';

const userGroupApi = {
  getUserGroupList() {
    const reqEndPoint = 'users/get-usergroup-details-for-user';
    return ApiServiceWrapper.get<UserGroupReponse>(reqEndPoint);
  },
  getUserGroupListForMsspId(data: any) {
    const reqEndPoint = 'users/get-usergroup-details-for-users';
    return ApiServiceWrapper.post<UserGroupReponse>(reqEndPoint, data);
  },
  getUserGroupPermissionList(id: string) {
    const reqEndPoint = `users/getusergrouppermissions?partygroupid=${id}&source=MSSPACCESSMGMT`;
    return ApiServiceWrapper.get(reqEndPoint);
  },
  addUserGroup(data: any) {
    const reqEndPoint = 'users/create-user-groups';
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  getUserList(data: any) {
    const reqEndPoint = 'users/list-users-for-usergroup';
    return ApiServiceWrapper.post<any>(reqEndPoint, data);
  },
  deleteUser(data: any) {
    const reqEndPoint = 'users/manage-users';
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  saveUserPermission(data: any) {
    const reqEndPoint = 'users/save-user-group-permissions';
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  getUserProductGroupList() {
    const reqEndPoint = 'users/get-productgroup-details-for-user';
    return ApiServiceWrapper.get<any>(reqEndPoint);
  },
  saveUserGroupScope(data: any) {
    const reqEndPoint = 'users/save-mssp-scope';
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  saveUsersToUserGroup(data: any) {
    const reqEndPoint = 'users/manage-users';
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  saveUserGroupTenantScope(data: any) {
    const reqEndPoint = 'users/manage-party-product-group';
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  getUserGroupScopeData(id: string, msspId: string) {
    const reqEndPoint = `users/list-productgroups-for-usergroup?usergroupid=${id}&masterMsspId=${msspId}`;
    return ApiServiceWrapper.get(reqEndPoint);
  },
};

export default userGroupApi;
